import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';

import { AuthService } from '../auth/auth.service';
import { TokenStorageService } from '../auth/token-storage.service';
import { first } from 'rxjs/operators';
import { UsersService } from '../services/users.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';

@Component({
    selector     : 'login',
    templateUrl  : './login.component.html',
    styleUrls    : ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class LoginComponent implements OnInit
{
    loginForm: FormGroup;
    isLoggedIn = false;
    isLoginFailed = false;
    errorMessage = '';
    roles: string[] = [];
    role: number[];
    ztStatus: string;
    ztQr: string;
    tokenDeshabilitado: boolean = false;
    tokenBloqueado: boolean = false;
    enrolado: boolean = true;
    durationInSeconds = 5;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private authService: AuthService,
        private tokenStorage: TokenStorageService,
        private _fuseNavigationService: FuseNavigationService,
        private usersService: UsersService,
        private _snackBar: MatSnackBar,
        public router: Router,
        private route: ActivatedRoute
    )
    {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar   : {
                    hidden: false
                },
                toolbar  : {
                    hidden: true
                },
                footer   : {
                    hidden: true
                },
                sidepanel: {
                    hidden: false
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    //Hola
    /**
     * On init
     */
    ngOnInit(): void
    {
        this.loginForm = this._formBuilder.group({
            email   : ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });
        if (this.tokenStorage.getToken()) {
            this.isLoggedIn = true;
            this.roles = this.tokenStorage.getUser().roles;
        }
    }

    onSubmit(): void {

        this.ztStatus="";
        this.ztQr="";
        this.tokenDeshabilitado = false;
        this.tokenBloqueado= false;
        this.enrolado= true;

        this.authService.login(this.loginForm.value).pipe(first()).subscribe(
          data => {
            this.tokenStorage.saveToken(data.headers.get('authorization'));
            this.tokenStorage.saveUser(this.loginForm.value.email.toLowerCase());


            this.isLoginFailed = false;
            this.isLoggedIn = true;
            this.roles = this.tokenStorage.getUser().roles;
            this.role = this.tokenStorage.getRole();
            this.ztStatus = this.tokenStorage.getZTStatus();
            

            console.log("ZTStatus:"+this.ztStatus);

            if(this.ztStatus ==="CLOSED"){
                this.tokenDeshabilitado = true;
            }

            if(this.ztStatus ==="BLOCKED"){
                this.tokenBloqueado= true;
            }
            
            if(this.ztStatus=== undefined || this.ztStatus ==="AWAITING_ENROLLMENT"){
                this.enrolado = false;

                this.usersService.enroll().pipe(first()).subscribe(
                    data => {
                        this.ztQr = data.body.qr;
                        console.log("Bse64 token:" +this.ztQr);
                    }
                );

            }

            if(this.ztStatus ==="OPEN"){
                this.usersService.generateMenu(this.role);
                this.router.navigate(['../usuarios'], { relativeTo: this.route });
            }
            
          },
          err => {
            console.log(err);
            this._snackBar.open('El usuario o password son incorrectos', 'close', {
                duration: this.durationInSeconds * 1000,
            });
            this.errorMessage = err.error.message;
            this.isLoginFailed = true;
          }
        );
    }
}
